import { Box, styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.primary.main,
  height: '22.5rem',
  borderRadius: '0.5rem',
  padding: '1.25rem',
  gap: '1rem',
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  justifyContent: 'flex-start',
  height: '100%',
}));

export const SpaceBetween = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
}));

export const EditIconStyled = styled('img')(() => ({
  fontSize: '1.5rem',
}));

export const AlignStatusContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  gap: '1rem',
  alignItems: 'center',
}));

export const BoxCustom = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '.5rem',
  overflow: 'auto',
}));
